import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import CreatRequest from "../views/requests/Create.vue";
import ShowRequest from "../views/requests/Show.vue";
import Login from "../views/Login.vue";
import store from "../store/index";
import Users from "../views/users/masterUser.vue";
import ConfirmDispatch from "../views/requests/confirmDispatch/confirmDispatch.vue";
import SampleTargets from "../views/sampleTargets/masterSampleTarget.vue";
import BusinessUnits from "../views/businessUnits/masterBusinessUnits.vue";
import CostCenters from "../views/costCenter/masterCostCenter.vue";
import roles from "../global/roles";
import ShowInternalDispatch from "../views/requests/internalDispatch/Show.vue";
import ShowExternalDispatch from "../views/requests/externalDispatch/Show.vue";
import ShowLitDispatch from "../views/requests/confirmDispatch/Show.vue";
import ShowListWineryDispatched from "../views/requests/requestWineryDispatched/Show.vue";
import ShowListRequest from "../views/requests/showRequest/Show.vue";
import ChangePassword from "../views/users/changePassword.vue";
import Courier from "../views/couriers/masterCourier.vue";
import ShowValidWineryDispatch from "../views/requests/validWineryDispatch/Show.vue";
import Formulas from "../views/formulas/masterFormulas.vue";
import MasterItems from "../views/masterItems/masterItems.vue";
import MaterialFamilies from "../views/materialfamilies/masterMaterialFamilies";
import quality from "@/views/requests/quality/quality.vue";
import ShowApprove from "@/views/requests/internalDispatch/ShowApprove.vue";
import Notifications from '@/views/notification/masterNotification.vue'
import Dashboard from '@/views/dashboard/dashboard.vue'
import HotExpressTracking from '@/views/hotExpress/HotExpressTracking.vue'
import HotExpressTrackingDetail from '@/views/hotExpress/HotExpressTrackingDetail.vue'
import MasterSampleReason from '@/views/sampleReason/masterSampleReason.vue'
import MicrosoftCallback from '@/views/MicrosoftCallback.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: '/microsoft-callback',
		name: 'MicrosoftCallback',
		component: MicrosoftCallback
	},
	{
		path: "/dashboard",
		name: "Dashboard",
		component: Dashboard,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/crear",
		name: "CreateRquest",
		component: CreatRequest,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/ver/:id",
		name: "ShowRquest",
		component: ShowRequest,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/login",
		name: "Login",
		component: Login,
	},
	{
		path: "/users",
		name: "MasterUsers",
		component: Users,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/notifications",
		name: "Notifications",
		component: Notifications,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/sampletargets",
		name: "MasterSampleTargets",
		component: SampleTargets,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/couriers",
		name: "MasterCourier",
		component: Courier,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/validar/:id",
		name: "ShowValidWineryDispatch",
		component: ShowValidWineryDispatch,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/despacho/bodega/:id",
		name: "ShowInternalDispatch",
		component: ShowInternalDispatch,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/despacho/:id",
		name: "ShowExternalDispatch",
		component: ShowExternalDispatch,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/confirmar/:id",
		name: "ConfirmInternalDispatch",
		component: ShowLitDispatch,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/visualizar/:id",
		name: "ShowListRequest",
		component: ShowListRequest,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/despachadas",
		name: "ShowListWineryDispatched",
		component: ShowListWineryDispatched,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/calidad/:id",
		name: "ShowQuality",
		component: quality,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/solicitudes/validar/despacho/:id",
		name: "ShowDispatchApprove",
		component: ShowApprove,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/costcenters",
		name: "MasterCostCenters",
		component: CostCenters,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/changepassword",
		name: "ChangePassword",
		component: ChangePassword,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/businessunits",
		name: "MasterBusinessUnits",
		component: BusinessUnits,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/roles",
		name: "Roles",
		component: roles,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/confirmar",
		name: "Confirmar",
		component: ConfirmDispatch,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/formulas",
		name: "Formulas",
		component: Formulas,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/masteritems",
		name: "MasterItems",
		component: MasterItems,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/materialfamilies",
		name: "MaterialFamilies",
		component: MaterialFamilies,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/hotexpress-tracking",
		name: "HotExpressTracking",
		component: HotExpressTracking,
		meta: {
			requireAuth: true,
		},
	},
	{
		path: "/hotexpress-tracking-detail/:id",
		name: 'HotExpressTrackingDetail',
		component: HotExpressTrackingDetail,
		meta: {
			requireAuth: true,
		}
	},
	{
		path: "/samplereasons",
		name: 'SampleaReason',
		component: MasterSampleReason,
		meta: {
			requireAuth: true,
		}
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});



router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requireAuth)) {
		if (!store.getters.user) {
			next({
				path: "/login",
				query: { redirect: to.fullPath },
			});
		} else {
			if (to.matched.some((record) => record.meta.allowedRoles)) {
				let canIn = false;
				to.meta.allowedRoles.forEach((role) => {
					if (Array.isArray(store.getters.user.roles)) {
						if (store.getters.user.roles.filter((a) => a === role).length > 0) {
							canIn = true;
						}
					} else {
						if (store.getters.user.roles === role) {
							canIn = true;
						}
					}
				});
				if (canIn) next();
				else {
					next({
						path: "/login",
						query: { redirect: to.fullPath },
					});
				}
			}
			next();
		}
	} else {
		next();
	}
});


export default router;
